import React from "react";
import { observer } from "mobx-react-lite";

import { Error } from "../svg/svgImageList";
import Svg from "../svg/Svg";
import { translationService } from "../../services/translation/TranslationService";
import { ApplicationError } from "../../services/error-handler/ErrorHandlerService";

interface DataGridErrorProps {
  error: ApplicationError;
}

const errorMessage = "default-error";

export default observer(function DataGridError({ error }: DataGridErrorProps) {
  return (
    <div id="table-error" className="data-grid-error">
      <Svg svg={Error} />
      <p className="error-text">{translationService.translate(errorMessage)}</p>
    </div>
  );
});
